import React from 'react';
import { FadeIn } from './FadeIn';
export function ProblemSection() {
  return <section className="py-20 bg-gray-50" data-id="element-210">
      <div className="container px-4 mx-auto max-w-3xl" data-id="element-211">
        <FadeIn data-id="element-212">
          <h2 className="mb-8 text-3xl font-bold text-gray-900 md:text-4xl text-center" data-id="element-213">
            El estado de "Supervivencia Metabólica"
          </h2>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-214">
          <div className="prose prose-lg md:prose-xl text-gray-800 leading-[1.8]" data-id="element-215">
            <p data-id="element-216">
              A partir de los 40 años, tu cuerpo entra en un estado de
              "supervivencia metabólica". Debido a la caída de estrógeno y
              testosterona, tu metabolismo basal se desploma.
            </p>
            <p data-id="element-217">
              Vives con fatiga a las 4 de la tarde, hinchazón abdominal cada
              noche y esa capa de grasa que se niega a irse, sin importar
              cuántas ensaladas comas o cuántos kilómetros camines.
            </p>
            <p className="font-semibold text-red-600" data-id="element-218">
              El error es creer que "comer menos" es la solución, cuando en
              realidad, eso es lo que mantiene tu metabolismo apagado.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}